import { render, staticRenderFns } from "./TrainingReportsPagesContainer.vue?vue&type=template&id=89da3c0c&"
import script from "./TrainingReportsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./TrainingReportsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports